/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// constants
export const FILE_TYPE_IMAGES = ["image/jpeg", "image/jpg", "image/png"];
const FILE_UPLOADER_ID = "file-uploader";
const ONE_KILOBYTE = Number("1024");
const ONE_GIGABYTE = Math.pow(ONE_KILOBYTE, Number("3"));

class FileUtils {
  /**
  * @param {String} dataUrl
  * @param {String} contentType
  * @param {String} name
  */
   static download(dataUrl, {
    contentType = "image/png",
    name = "download"
  } = {}) {
    const download = window.document.createElement("a");
    const fileType = String(contentType)
      .substring(String(contentType)
      .lastIndexOf("/") + 1);
    download.download = `${name}.${fileType}`;
    download.href = dataUrl;
    download.style = "none";
    window.document.body.appendChild(download);
    download.click();
    window.document.body.removeChild(download);
  }

  /**
  * @returns {String}
  */
  static getUploadElementId() { return String(FILE_UPLOADER_ID); }

  /**
  * @param {String[]} fileTypesAllowed
  * @param {Number} maxFileSelectionCount
  * @param {Number} maxFileSelectionSize
  * @returns {Object} fileSelection = {
  *   files: {Object[]}
  *   fileTypes: {String[]}
  *   size: {Number}
  * }
  */
  static upload({
    allowedFileTypes = [...FILE_TYPE_IMAGES],
    maxFileSelectionCount = Number.MAX_SAFE_INTEGER,
    maxFileSelectionSize = Number(ONE_GIGABYTE)
  } = {}) {
    return new Promise((resolve, reject) => {
      const fileInput = window.document.getElementById(FILE_UPLOADER_ID);
      fileInput.multiple = maxFileSelectionCount > 1;
      fileInput.value = "";
      fileInput.onchange = (e) => {
        const uploadFiles = e.target.files;

        // check file count
        if(uploadFiles.length > maxFileSelectionCount) {
          reject(`Too many files selected, maximum allowed: "${maxFileSelectionCount}".`);
        }
        else {
          const fileSelection = {
            files: [ ...uploadFiles ],
            fileTypes: [],
            size: Number("0")
          };

          // verify the files are all an accepted type
          // and sum total upload size
          let fileTypesInvalid = false;
          Array.from(uploadFiles).forEach((value) => {
            const targetFile = value;
            const targetFileType = String(targetFile["type"]);
            if (allowedFileTypes.includes(targetFileType)) {
              fileSelection.size = Number(fileSelection.size) + Number(targetFile.size);
              if(!fileSelection.fileTypes.includes(targetFileType)) {
                fileSelection.fileTypes.push(targetFileType);
              }
            }
            else {
              fileTypesInvalid = false;
            }
          });

          // reject invalid types
          if(fileTypesInvalid) {
            reject(
              `Invalid file type. ` +
              `Accepted file types are: ` +
              `${allowedFileTypes.join(", ")}`
            );
          }

          // reject size too large
          else if(fileSelection.size > maxFileSelectionSize) {
            const uploadSizeAllowed = `${Number(maxFileSelectionSize / ONE_GIGABYTE).toFixed(1)}GB`;
            reject(`File upload too large, maximum allowed: "${uploadSizeAllowed}".`);
          }

          // resolve
          else {
            resolve(fileSelection);
          }
        }
      };
      fileInput.click();
    });
  }
}
export default FileUtils;
